import { useEffect } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { api } from '../api/client';
import { useI18n } from '../i18n';
import { appPathFor } from '../hooks/deepLink';
import { ListSkeleton } from '../components/ui';

/**
 * Notification / share link paths (/order/x, /restaurant/x, /wallet, /refer, …) land here and are
 * sent to the matching screen. The query string is kept so `?offer=` / `?scan=` / `?ref=` still
 * reach the entry capture.
 */
export function DeepLinkRedirect() {
  const location = useLocation();
  return <Navigate to={appPathFor(`${location.pathname}${location.search}`)} replace />;
}

/**
 * A restaurant QR short link opened inside the app (/q/<slug>). The API records the scan and
 * redirects back to the web app with the offer and scan token, which the entry capture stores.
 */
export function QrEntryPage() {
  const { t } = useI18n();
  const { slug = '' } = useParams();
  useEffect(() => {
    const clean = slug
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9_-]/g, '')
      .slice(0, 40);
    const base = api.defaults.baseURL ?? window.location.origin;
    window.location.replace(new URL(`/q/${clean}`, base).toString());
  }, [slug]);
  return (
    <div className="min-h-dvh bg-page px-4 pt-10">
      <p className="mb-4 text-center text-sm font-medium text-ink-2">{t('deeplink.opening')}</p>
      <ListSkeleton rows={3} tall />
    </div>
  );
}
